import { z } from 'zod';
const defs = [
    {
        key: 'shop.name',
        section: 'boutique',
        label: 'Raison sociale',
        type: 'string',
        default: 'John Saks',
        public: true,
    },
    {
        key: 'shop.whatsapp',
        section: 'boutique',
        label: 'WhatsApp',
        type: 'phone',
        default: '+243827253109',
        public: true,
    },
    {
        key: 'shop.supportEmail',
        section: 'boutique',
        label: 'E-mail infos',
        type: 'email',
        default: 'infos@johnsaks.com',
        public: true,
    },
    {
        key: 'shop.supportContactEmail',
        section: 'boutique',
        label: 'E-mail support',
        type: 'email',
        default: 'support@johnsaks.com',
        public: true,
    },
    {
        key: 'shop.ordersPaused',
        section: 'boutique',
        label: 'Suspendre les commandes',
        type: 'boolean',
        default: false,
        public: true,
    },
    {
        key: 'shop.announcement',
        section: 'boutique',
        label: 'Bandeau d’annonce',
        type: 'string',
        default: '',
        public: true,
    },
    {
        key: 'social.instagram',
        section: 'reseaux',
        label: 'Instagram',
        type: 'string',
        default: 'https://www.instagram.com/johnsaks',
        public: true,
        description: 'URL complète du profil Instagram',
    },
    {
        key: 'social.facebook',
        section: 'reseaux',
        label: 'Facebook',
        type: 'string',
        default: 'https://www.facebook.com/johnsaks',
        public: true,
        description: 'URL complète de la page Facebook',
    },
    {
        key: 'social.tiktok',
        section: 'reseaux',
        label: 'TikTok',
        type: 'string',
        default: 'https://www.tiktok.com/@johnsaks',
        public: true,
        description: 'URL complète du profil TikTok',
    },
    {
        key: 'social.x',
        section: 'reseaux',
        label: 'X (Twitter)',
        type: 'string',
        default: '',
        public: true,
        description: 'URL complète du profil X, laisser vide pour masquer',
    },
    {
        key: 'payments.codEnabled',
        section: 'paiements',
        label: 'Paiement à la livraison',
        type: 'boolean',
        default: true,
        public: true,
    },
    {
        key: 'payments.codMaxCents',
        section: 'paiements',
        label: 'Plafond COD (cents USD)',
        type: 'cents',
        default: 50000,
        min: 0,
        max: 10_000_000,
    },
    {
        key: 'payments.mobileMoneyEnabled',
        section: 'paiements',
        label: 'Mobile money',
        type: 'boolean',
        default: false,
        public: true,
    },
    {
        key: 'payments.bankTransferEnabled',
        section: 'paiements',
        label: 'Virement',
        type: 'boolean',
        default: false,
        public: true,
    },
    {
        key: 'orders.pendingAutoCancelHours',
        section: 'commandes',
        label: 'Annulation auto (h)',
        type: 'int',
        default: 48,
        min: 1,
        max: 168,
    },
    {
        key: 'orders.maxLineQty',
        section: 'commandes',
        label: 'Qté max par ligne',
        type: 'int',
        default: 10,
        min: 1,
        max: 99,
    },
    {
        key: 'orders.referencePrefix',
        section: 'commandes',
        label: 'Préfixe références',
        type: 'string',
        default: 'JS',
    },
    {
        key: 'inventory.saleMoment',
        section: 'stock',
        label: 'Moment du déstockage',
        type: 'enum',
        default: 'SHIPPED',
        enumValues: ['CONFIRMED', 'SHIPPED', 'DELIVERED'],
    },
    {
        key: 'inventory.defaultThreshold',
        section: 'stock',
        label: 'Seuil bas par défaut',
        type: 'int',
        default: 3,
        min: 0,
        max: 999,
    },
    {
        key: 'inventory.reservationHours',
        section: 'stock',
        label: 'Durée réservation (h)',
        type: 'int',
        default: 48,
        min: 1,
        max: 168,
    },
    {
        key: 'discretion.handoverCodeLength',
        section: 'discretion',
        label: 'Longueur code remise',
        type: 'int',
        default: 4,
        min: 4,
        max: 8,
        public: true,
    },
    {
        key: 'discretion.parcelSender',
        section: 'discretion',
        label: 'Expéditeur colis',
        type: 'string',
        default: 'JS Logistics',
    },
];
export const SETTINGS_REGISTRY = defs;
export const SETTINGS_BY_KEY = Object.fromEntries(SETTINGS_REGISTRY.map((d) => [d.key, d]));
export const PUBLIC_SETTING_KEYS = SETTINGS_REGISTRY.filter((d) => d.public).map((d) => d.key);
/** Anciennes clés → nouvelles (script de reprise). */
export const SETTINGS_KEY_ALIASES = {
    payment_cod_enabled: 'payments.codEnabled',
    support_email: 'shop.supportEmail',
    whatsapp_number: 'shop.whatsapp',
    shop_name: 'shop.name',
};
export function settingZod(def) {
    switch (def.type) {
        case 'boolean':
            return z.boolean();
        case 'int':
        case 'cents': {
            let s = z.number().int();
            if (def.min != null)
                s = s.min(def.min);
            if (def.max != null)
                s = s.max(def.max);
            return s;
        }
        case 'email':
            return z.string().email();
        case 'phone':
            return z.string().min(8).max(20);
        case 'enum':
            return z.enum((def.enumValues ?? ['x']));
        case 'json':
            return z.unknown();
        default:
            return z.string();
    }
}
export function validateSettingValue(key, value) {
    const def = SETTINGS_BY_KEY[key];
    if (!def)
        throw new Error(`Clé de réglage inconnue : ${key}`);
    return settingZod(def).parse(value);
}
export function defaultsMap() {
    return Object.fromEntries(SETTINGS_REGISTRY.map((d) => [d.key, d.default]));
}
//# sourceMappingURL=settings.js.map